export default class ContentLayoutComponent {
	constructor() {
		this.template = '<ui-view/>';
	}
}

ContentLayoutComponent.META = {
	name: 'contentLayout',
	state: {
        isDistributionState: true,
        url: '',
		name: 'contentLayout',
		abstract: true,
		template: '<content-layout class="distribution-layout"></content-layout>',
		parent: 'app-layout',
	}
};



// WEBPACK FOOTER //
// ./modules/distribution/layouts/content/component/content.layout.component.js